import { HoneycombWebSDK } from '@honeycombio/opentelemetry-web';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';

// Just a stub for now, we will add more configuration later.
const configDefaults = {};

const localStorageKey = 'hydra:honeycomb-ui-enabled';

// Currently we only enable Honeycomb manually through localStorage for testing purposes.
// Using localStorage instead of a feature flag because we need it enabled as soon as
// possible to better capture traces, and feature flags are not available yet.
export function isHoneycombEnabled() {
  try {
    return localStorage.getItem(localStorageKey) === 'true';
  } catch {
    return false;
  }
}
export function setupHoneycomb() {
  if (!isHoneycombEnabled()) {
    return;
  }

  const sdk = new HoneycombWebSDK({
    debug: __CIO_ENV__ !== 'production',
    // Test API key, does not point to the production Honeycomb account,
    // but to a free account that allows us to test the integration.
    apiKey: 'hcaik_01jz3wbp9angy29meegg1bbd4cvtsj2nfg6pv4x9qbs24t4pzmy8tg6rba',
    serviceName: 'hydra-ui',
    sampleRate: 1,
    instrumentations: [
      getWebAutoInstrumentations({
        '@opentelemetry/instrumentation-xml-http-request': configDefaults,
        '@opentelemetry/instrumentation-fetch': configDefaults,
        '@opentelemetry/instrumentation-document-load': configDefaults,
      }),
    ],
  });

  sdk.start();
}
